/* Mobile rail: en mobile (<768px) convierte grillas [data-mobile-rail]
   en carrusel con scroll-snap (1.5 cards visibles) + guiones de navegación. */
(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  function setup(rail) {
    if (rail._railReady) return;
    rail._railReady = true;

    var dots = document.createElement('div');
    dots.className = 'mobile-rail__dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Navegación del carrusel');
    rail.insertAdjacentElement('afterend', dots);

    var stops = [];
    var ticking = false;

    function items() {
      return Array.prototype.filter.call(rail.children, function (el) {
        return el.nodeType === 1 && el.offsetParent !== null;
      });
    }

    function build() {
      dots.innerHTML = '';
      stops = [];
      if (!MQ.matches) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 2) return;
      var base = rail.getBoundingClientRect().left - rail.scrollLeft;
      var pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
      items().forEach(function (el) {
        var pos = Math.min(Math.max(el.getBoundingClientRect().left - base - pad, 0), max);
        if (!stops.length || pos - stops[stops.length - 1] > 4) stops.push(pos);
      });
      if (max - stops[stops.length - 1] > 4) stops.push(max);
      stops.forEach(function (pos, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mobile-rail__dot';
        b.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
        b.addEventListener('click', function () {
          rail.scrollTo({ left: pos, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      update();
    }

    function update() {
      ticking = false;
      if (!stops.length) return;
      var x = rail.scrollLeft, best = 0, d = Infinity;
      stops.forEach(function (pos, i) {
        var dd = Math.abs(pos - x);
        if (dd < d) { d = dd; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (b, i) {
        var on = i === best;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    rail.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });

    var t;
    function rebuild() { clearTimeout(t); t = setTimeout(build, 120); }
    window.addEventListener('resize', rebuild);
    if (MQ.addEventListener) MQ.addEventListener('change', rebuild);
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', rebuild, { once: true });
    });
    build();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mobile-rail]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
